import React, { useEffect, useState } from "react";
import { getData } from "../../Tools/helpers";

import FormCustom from "../../components/FormCustom";
import TableCustom from "../../components/TableCustom";

const DIRECTOR_ALLOWED_PERMISSIONS = ["cajero", "cajero_pagos"];
const DIRECTOR_ALLOWED_POSITIONS = ["finanzas"];

const Staff = () => {
  const [userData] = useState(JSON.parse(localStorage.getItem("USER_IUMV")));
  const isDirector = userData?.abbreviation === "director";

  const [dataTable, setDataTable] = useState([]);
  const [dataForm, setDataForm] = useState({});
  const [isTrueUpdateData, setIsTrueUpdateData] = useState(false);
  const [isTrueDeleteData, setIsTrueDeleteData] = useState(false);

  const [listPositions, setListPositions] = useState([]);
  const [listUniversities, setListUniversities] = useState([]);
  const [lisrPermissions, setListPermissions] = useState([]);

  const allFields = [
    { name: "name", label: "Nombre completo", required: "true" },
    { name: "curp", label: "Curp", required: "true" },
    { name: "phone", label: "Teléfono", required: "false" },
    { name: "email", label: "Email", required: "false" },
    {
      name: "position_id",
      label: "Puesto",
      required: "true",
      type: "select",
      list: isDirector
        ? listPositions.filter((p) => DIRECTOR_ALLOWED_POSITIONS.includes(p.description?.toLowerCase()))
        : listPositions,
      field_select_description: "description",
    },
    {
      name: "university_id",
      label: "Campus",
      required: "true",
      type: "select",
      list: listUniversities,
      field_select_description: "name",
    },
    { name: "password", label: "Contraseña", required: "true", type: "password" },
    {
      name: "permission_id",
      label: "Tipo de usuario",
      required: "true",
      type: "select",
      list: isDirector
        ? lisrPermissions.filter((p) => DIRECTOR_ALLOWED_PERMISSIONS.includes(p.abbreviation))
        : lisrPermissions,
      field_select_description: "description",
    },
  ];

  const FieldsCustom = isDirector
    ? allFields.filter((f) => f.name !== "university_id")
    : allFields;

  const FieldsCustomTable = [
    { name: "name", label: "Nombre completo", required: "true" },
    { name: "curp", label: "Curp", required: "true" },
    { name: "phone", label: "Teléfono", required: "false" },
    { name: "email", label: "Email", required: "true" },
    { name: "description", label: "Puesto", required: "true" },
    { name: "university_name", label: "Campus", required: "true" },
    { name: "descripcion_permissions", label: "Permiso de usuario", required: "true" },
  ];

  const routeForm = "Staff";

  const getStaff = async () => {
    const route = routeForm;
    const send = await getData(route);
    console.log(send);
    if (send.code === 200) {
      setDataTable(send.data);
    }
  };

  const getPosition = async () => {
    const route = "Position";
    const send = await getData(route);
    if (send.code === 200) {
      setListPositions(send.data);
    }
  };

  const getUniversities = async () => {
    const route = "University";
    const send = await getData(route);
    if (send.code === 200) {
      setListUniversities(send.data);
    }
  };

  const getPermissions = async () => {
    const route = "Permission";
    const send = await getData(route);
    if (send.code === 200) {
      setListPermissions(send.data);
    }
  };

  useEffect(() => {
    getStaff();
    getPosition();
    getPermissions();
    if (isDirector) {
      setDataForm({ university_id: userData.university_id });
    } else {
      getUniversities();
    }
  }, []);

  return (
    <div className="flex-1">
      <div className=" mb-10 max-w-2xl">
        <FormCustom
          fields={FieldsCustom}
          title="DATOS DE PERSONAL"
          route={routeForm}
          method="post"
          setData={setDataForm}
          data={dataForm}
          fieldDialog="name"
          setIsTrueUpdateData={setIsTrueUpdateData}
          isTrueUpdateData={isTrueUpdateData}
          refreshDataList={getStaff}
          setIsTrueDeleteData={setIsTrueDeleteData}
          isTrueDeleteData={isTrueDeleteData}
        />
      </div>
      <div className="flex-1">
        <TableCustom
          fields={FieldsCustomTable}
          setDataForm={setDataForm}
          data={dataTable}
          setIsTrueUpdateData={setIsTrueUpdateData}
          setIsTrueDeleteData={setIsTrueDeleteData}
        />
      </div>
    </div>
  );
};

export default Staff;
